<template>
    <div>
        <taplink-device preview>
            <upload-images
                v-model="content.image"
                @change="uploadImage"
                :style="[
                    { maxWidth: content.size.enable ? content.size.maxWidth + 'px' : '100%' },
                    { margin: '0 auto' }
                ]"
            />
        </taplink-device>
        <section class="row-section">
            <switch-checkbox row title="Установить максимальную ширину" v-model="content.size.enable" />
            <div class="hidden-box" v-if="content.size.enable">
                <input-addons
                    style="width: 100px"
                    type="number"
                    placeholder="768"
                    addon="px"
                    v-model="content.size.maxWidth"
                />
            </div>
        </section>
        <section class="row-section">
            <switch-checkbox row title="Сделать баннер ссылкой" v-model="content.action.enable" />
            <div class="hidden-box" v-if="content.action.enable">
                <v-select
                    name="banner-link-type"
                    :options="linkTypes"
                    style="max-width: 200px"
                    v-model="content.action.type"
                />
                <v-input name="banner-link" placeholder="https://" v-model="content.action.url" />
            </div>
        </section>
    </div>
</template>

<script>
import SwitchCheckbox from "@/updated/common/components/form/SwitchCheckbox";
import InputAddons from "../common/InputAddons";
import UploadImages from "../common/UploadImages";
import TaplinkDevice from "../common/TaplinkDevice";

const linkTypes = [
    { value: "link", label: "Открыть сайт" },
    { value: "tel", label: "Позвонить" },
    { value: "message", label: "SMS" },
    { value: "email", label: "Отправить эл.письмо" }
];
export default {
    name: "TaplinkBanner",
    components: {
        SwitchCheckbox,
        InputAddons,
        UploadImages,
        TaplinkDevice
    },
    props: {
        content: {}
    },
    data() {
        return {
            linkTypes
        };
    },
    watch: {
        content(val) {
            console.log(val, "taplink banner");
        }
    },
    methods: {
        uploadImage(img) {
            this.$set(this.content, "image", img);
        }
    }
};
</script>

<style lang="scss">
.hidden-box {
    margin-top: 10px;
    .select {
        margin-bottom: 15px;
    }
}
</style>
